import { Spinner } from '../Spinner';

export function QueryLoading(): JSX.Element {
  return <Spinner isCentered size={40} thickness={1.5} />;
}
